import {createContext, useContext} from 'react';
import useActiveSessionLoader from '../hooks/useActiveSessionLoader';
import useAgentChat from '../hooks/useAgentChat';

const AgentChatContext = createContext(null);

export function AgentChatProvider({children}) {
  const sessionLoader = useActiveSessionLoader();
  const chat = useAgentChat(sessionLoader);

  const value = {
    ...chat,
    ...sessionLoader,
  };

  return (
    <AgentChatContext.Provider value={value}>{children}</AgentChatContext.Provider>
  );
}

export function useAgentChatContext() {
  const context = useContext(AgentChatContext);
  if (!context) {
    throw new Error('useAgentChatContext must be used within AgentChatProvider');
  }
  return context;
}
